export const APP_STATE_KEYS = {
  AUTH_STATE: "AUTH_STATE",
  SIDE_BAR_STATE: "IS_COLLAPSED",
  UI_SETTTING_STATE: "UI_SETTING",
};
